const support = [{
	//客服查詢 - 帳號紀錄
	path: "support/history",
	name: "AdminSupportHistory",
	meta: {
		permission: 15001,
		breadcrumb: [{
			key: 'admin.support.subject',
			value: null
		}, {
			key: 'admin.support.history.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/support/history/index.vue"),
}, {
	//客服查詢 - 意見與建議
	path: "support/feedback",
	name: "AdminSupportFeedback",
	meta: {
		permission: 15011,
		breadcrumb: [{
			key: 'admin.support.subject',
			value: null
		}, {
			key: 'admin.support.feedback.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/support/feedback/index.vue"),
}, {
	//客服查詢 - 意見與建議 - 編輯
	path: "support/feedback/edit/:uuid",
	name: "AdminSupportFeedbackEdit",
	meta: {
		permission: 15014,
		breadcrumb: [{
			key: 'admin.support.subject',
			value: null
		}, {
			key: 'admin.support.feedback.index',
			value: "AdminSupportFeedback"
		}, {
			key: 'admin.support.feedback.edit',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/support/feedback/edit.vue"),
}, {
	//客服查詢 - 請我們喝咖啡
	path: "support/coffee",
	name: "AdminSupportCoffee",
	meta: {
		permission: 15021,
		breadcrumb: [{
			key: 'admin.support.subject',
			value: null
		}, {
			key: 'admin.support.coffee.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/support/coffee/index.vue"),
}, {
	//客服查詢 - 請我們喝咖啡 - 編輯
	path: "support/coffee/edit/:uuid",
	name: "AdminSupportCoffeeEdit",
	meta: {
		permission: 15024,
		breadcrumb: [{
			key: 'admin.support.subject',
			value: null
		}, {
			key: 'admin.support.coffee.index',
			value: "AdminSupportCoffee"
		}, {
			key: 'admin.support.coffee.edit',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/support/coffee/edit.vue"),
}];

export default support;
